// extracted by mini-css-extract-plugin
export default {"triggerButton":"TriggerMatchButton_triggerButton__Jb-6Z"};